import {useCurrentOfficeStore} from "../../api/CurrentOfficeStore";
import React from "react";
import {BERLIN_OFFICE_ID} from "../../util/OfficePath";
import {UploadButton} from "./UploadButton";

export function UploadBerlinVisitReportButton() {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);

    return currentOfficeId === BERLIN_OFFICE_ID ? (
        <UploadButton accept=".xlsx"/>
    ) : null;
}
